import React from "react";
import PropTypes from "prop-types";
import ArenaHelmet from "arena/components/ArenaHelmet";

export default function BookHelmet({ content }) {
  const imageUrl =
    content?.verticalThumbnails?.[0]?.url || content?.thumbnails?.[0]?.url;

  return (
    <ArenaHelmet
      title={content.title}
      description={content.description}
      imageUrl={imageUrl}
    />
  );
}

BookHelmet.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    thumbnails: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string.isRequired,
      })
    ),
    verticalThumbnails: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string.isRequired,
      })
    ),
  }),
};
